angular.module('acme.view.application.importExport.jobExecution.controllers.importExportCreateJobModalController', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.directive.dataGrid',
  'acme.common.service.permissions',
  'acme.view.application.importExport.jobExecution.directives.importExportJobExecutionFileUpload',
  'acme.view.application.importExport.jobExecution.directives.importExportJobExecutionErrorGrid',
])
.controller('ImportExportCreateJobModalController', ImportExportCreateJobModalController);

/**
 * Controller responsible for showing the user the downloadable Outputs for a Export Job Execution
 * @class ImportExportCreateJobModalController
 * @constructor
 * @return {ImportExportCreateJobModalController} - Class instance
 */
function ImportExportCreateJobModalController(
  $q,
  $uibModalInstance,
  ValidateService,
  ImportJobsApiService,
  JOB_TYPE,
  type,
  job
) {
  Object.assign(this, {
    $q: $q,
    $uibModalInstance: $uibModalInstance,
    ValidateService: ValidateService,
    ImportJobsApiService: ImportJobsApiService,
    JOB_TYPE: JOB_TYPE,
    type: type,
    job: job
  });

  // TODO: update ui-router to 0.3.0 to avoid calling this manually
  this.$onInit();
}

ImportExportCreateJobModalController.prototype.$onInit = function() {
  this.vm = this._getVm(this);
};

ImportExportCreateJobModalController.prototype._getVm = function (initialData) {
  var _data = initialData || {},
    isSubmitted = _data.isSubmitted || false,
    errorMessage = _data.errorMessage || '',
    name = (_data.job && _data.job.name) || '',
    description = (_data.job && _data.job.description) || '',
    typeTitle = (_data.type === _data.JOB_TYPE.EXPORT ? 'Export' : 'Import');

  return {
    isSubmitted: isSubmitted,
    errorMessage: errorMessage,
    name: name,
    description: description,
    typeTitle: typeTitle
  };
};

ImportExportCreateJobModalController.prototype._getValidationRules = function () {
  return {
    name: { len: { value: this.vm.name } }
  };
};

ImportExportCreateJobModalController.prototype._getAllValidationRulesAsArray = function () {
  var rules = this._getValidationRules();

  return Object.keys(rules).map(function (rule) {
    return rules[rule];
  });
};

ImportExportCreateJobModalController.prototype.cancel = function () {
  this.$uibModalInstance.close();
};

ImportExportCreateJobModalController.prototype.save = function () {
  var self = this;

  self.vm.isSubmitted = true;

  if (!this.ValidateService.validate(this._getAllValidationRulesAsArray())) {
    self.vm.errorMessage = 'Please correct the errors below:';
    return;
  }

  self.createOrUpdate().then(function () {
      self.$uibModalInstance.close(true);
    }, function (errorMessage) {
      self.vm.isSubmitted = false;
      self.vm.errorMessage = errorMessage;
    });
};

ImportExportCreateJobModalController.prototype.createOrUpdate = function() {
  var self = this,
    createOrUpdate,
    errorMessage = self.job ? 'Unable to update Job, please try again' : 'Unable to create Job, please try again';

  if (self.job) {
    createOrUpdate = self.ImportJobsApiService.update(Object.assign({}, self.job, {
      description: self.vm.description
    }));
  } else {
    createOrUpdate = self.ImportJobsApiService.create(self.vm.name, self.vm.description, self.type);
  }

  return createOrUpdate
    .catch(function (response) {
      errorMessage = (response.data && response.data.message) || errorMessage;
      return self.$q.reject(errorMessage); // TODO TEST
    });
};

ImportExportCreateJobModalController.prototype.isValidJobName = function () {
  if (this.vm.isSubmitted) {
    return this.ValidateService.validate([this._getValidationRules().name]);
  }
  return true;
};

ImportExportCreateJobModalController.$inject = [
  '$q',
  '$uibModalInstance',
  'ValidateService',
  'ImportJobsApiService',
  'JOB_TYPE',
  'type',
  'job'
];
